module.exports = __webpack_public_path__ + "img/book.8871fe8c.png";